// extracted by mini-css-extract-plugin
module.exports = {"container":"product-intent_container__1rpP9","title":"product-intent_title__1kqPj","row":"product-intent_row__Jyxav"};